<template>
	<div class="List">
		<img v-if="searchShow && loadShow" src="../assets/loading.gif" alt="" class="loading">
		<van-list v-else class="listItem" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
			:immediate-check="false">
			<div class="card-item-inner" v-for="(item, index) in data_product_array" :key="index"
				@click="item.price > 0 || item.refPrice ? nextTick(item.id) : ''">
				<span class="card-item-inner-first">
					<img class="card-item-inner_img" v-lazy="item.imageUrl? item.imageUrl: item.picturePath" />
					<span class="bacSpace"></span>
					<span class="lm" v-if="tab_menu_array_index == 1 && specialarea == ''">
						<p class="lm-t">{{tab_menu_array_index == 1? '跟团游':'景点门票'}}</p>
						<p class="lm-b">{{tab_menu_array_index == 1? item.cfd+'出发':item.themeName}}</p>
					</span>
					<span class="lm" v-if="tab_menu_array_index == 1 && specialarea != ''">
						<label v-if="specialarea == ',2,'">
							<p v-if="endCityId > 0" class="lm-y">{{endCityName}}·研学游</p>
							<p v-else class="lm-y">研学游·{{item.cfd}}出发</p>
						</label>
						<label v-if="specialarea == ',3,'">
							<p v-if="endCityId > 0" class="lm-y">{{endCityName}}·火车游</p>
							<p v-else class="lm-y">火车游·{{item.cfd}}出发</p>
						</label>
						<label v-if="specialarea == ',4,'">
							<p v-if="endCityId > 0" class="lm-y">{{endCityName}}·海岛游</p>
							<p v-else class="lm-y">海岛游·{{item.cfd}}出发</p>
						</label>
					</span>
					<img class="self-icon" v-if="item.isself == 1"
						src="https://sweetour-pic.obs.cn-north-1.myhuaweicloud.com/sweetmini/group_self_icon.png"
						alt="">
				</span>
				<span class="card-item-inner-last">
					<h2 class="card-item-title">{{item.title}}</h2>
					<span class='price-content' v-if="item.price > 0 || item.refPrice">
						<p class='size-26'>￥</p>
						<p class='size-30'>{{item.price? item.price : item.refPrice}}</p>
						<p class='size-20'>起</p>
					</span>
					<span class="size-20 price-content gray" v-else>敬请期待</span>
				</span>
			</div>
		</van-list>
	</div>
</template>

<script>
	export default {
		name: 'List',
		props: {
			pickerArrayIndex: Number,
			pickerArray: Array,
			tab_menu_array_index: Number,
			ticketShow: Boolean,
			searchShow: Boolean,
			themeId: String,
			keyWord: String,
			cityId: Number
		},
		data() {
			return {
				loading: false,
				finished: false,
				data_product_array: [],
				page: 0,
				startCityId: 0,
				endCityId: 0,
				endCityName: '',
				specialarea: "", //星球少年 等其他请求
				loadShow: true,
				tourType: false //true出国游  false国内游
			}
		},
		methods: {
			nextTick(id) {
				if (this.tab_menu_array_index === 1) {
					this.$router.push({
						path: '/swimDetail',
						query: {
							id: id
						}
					})
				} else {
					this.$router.push({
						path: '/detail',
						query: {
							id: id
						}
					})
				}
			},
			onLoad() {
				setTimeout(() => {
					this.loading = false;
					this.page = this.page + 1
					this.connect_ProductList()
				}, 500);
			},
			getData(res, e) {
				res.objects.forEach(ele => {
					ele.pd_json = ele.pd_json != "" ? JSON.parse(ele.pd_json) : ""
					if (ele.pd_json != "") {
						ele.cfd = ''
						ele.pd_json.pod.forEach((le, i) => {
							if (i + 1 == ele.pd_json.pod.length) {
								ele.cfd = ele.cfd + le.Pod
							} else {
								ele.cfd = ele.cfd + le.Pod + '、'
							}
						})
					}
				})
				if (e) {
					this.data_product_array = res.objects
				} else {
					this.data_product_array = this.data_product_array.concat(res.objects)
				}
				if (res.objects.length < 10) {
					this.finished = true;
				}
			},
			connect_ProductList(e) {
				if (this.tab_menu_array_index == 1) {
					if (this.searchShow) {
						if (this.tourType) {
							var data = {
								pageIndex: this.page,
								pageSize: 10,
								object: {
									platformid: this.$platformid,
									title: this.keyWord,
									pods: this.startCityId ? [{
										podID: this.startCityId, //出发地 id
									}] : []
								}
							}
						} else {
							var data = {
								pageIndex: this.page,
								pageSize: 10,
								object: {
									platformid: this.$platformid,
									title: this.keyWord,
									pods: this.startCityId ? [{
										podID: this.startCityId, //出发地 id
									}] : [],
									destinations: this.endCityId ? [{
										destinationID: this.endCityId //目的地id
									}] : []
								}
							}
						}

					} else {
						if (this.specialarea !== '') {
							var data = {
								pageIndex: this.page,
								pageSize: 10,
								object: {
									platformid: this.$platformid,
									is_sny: 2,
									specialarea: this.specialarea,
									destinations: this.endCityId ? [{
										destinationID: this.endCityId //目的地id
									}] : [],
									proProperty: 1
								}
							}
						} else {
							var data = {
								pageIndex: this.page,
								pageSize: 10,
								object: {
									platformid: this.$platformid,
									is_sny: 2,
									proProperty: 1
								}
							}
						}

					}
					if (this.tourType) {
						// 出境
						this.$_post(
							this.$connectHttpDayun + '/team/mobile/indirect/pagefxwdcj', data
						).then(res => {
							this.loadShow = false
							this.getData(res, e)
						})
					} else {
						// 国内跟团
						this.$_post(
							this.$connectHttpDayun + '/team/mobile/indirect/pagefxwd', data
						).then(res => {
							this.loadShow = false
							this.getData(res, e)
						})
					}
				} else {
					if (this.ticketShow) {
						var data = {
							"merchantId": 0,
							"pageIndex": this.page,
							"tagName": '周边游',
							"organizationId": this.$organizationId,
							"isZeroShow": false,
							"themeId": this.themeId,
							"bigId": 0
						}
					} else if (this.searchShow) {
						var data = {
							"merchantId": 0,
							"pageIndex": this.page,
							"tagName": '周边游',
							"organizationId": this.$organizationId,
							"isZeroShow": true,
							"bigId": 0,
							"keyWord": this.keyWord,
							"city": this.cityId
						}
					} else {
						var data = {
							"keyWord": this.pickerArrayIndex == 0 ? '' : this.pickerArray[this.pickerArrayIndex].name,
							"pageIndex": this.page,
							"pageSize": 10,
							"organizationId": this.$organizationId,
							"isZeroShow": false,
							"bigId": 0
						}
					}
					// 景点门票
					this.$post(
						this.$apiList + '/NewNearTravel/GetNearTravel_List', data
					).then(res => {
						this.loadShow = false
						if (e) {
							this.data_product_array = res.result.tag.tagProductList
						} else {
							this.data_product_array = this.data_product_array.concat(res.result.tag.tagProductList)
						}
						if (res.result.tag.tagProductList.length < 10) {
							this.finished = true;
						}
					})
				}
			},
		},
		created() {

		}
	}
</script>

<style>
	.listItem {
		width: 100%;
		padding: 26px;
		box-sizing: border-box;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		align-items: center;
	}

	.card-item-inner {
		width: 336px;
		background-color: #fff;
		border-radius: 20px;
		margin-bottom: 16px;
		position: relative;
		height: 496px;
	}

	.card-item-inner-first {
		width: 100%;
		height: 324px;
		position: relative;
		display: flex;
	}

	.card-item-inner_img {
		width: 100%;
		height: 324px;
		border-radius: 20px 20px 0 0;
		object-fit: cover;
	}

	.bacSpace {
		width: 100%;
		height: 324px;
		position: absolute;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.15);
		border-radius: 20px 20px 0 0;
		z-index: 2;
	}

	.lm {
		position: absolute;
		top: 10px;
		left: 15px;
		color: #fff;
		font-size: 24px;
		z-index: 3;
	}

	.lm-t {
		display: inline;
		padding-bottom: 8px;
		border-bottom: 1px solid #fff;
	}

	.lm-b {
		margin-top: 10px;
		font-size: 22px;
	}

	.card-item-inner-last {
		width: 100%;
		height: 172px;
		padding: 20px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.card-item-title {
		font-size: 28px;
		line-height: 35px;
		font-family: PingFangSC-Semibold, sans-serif;
		color: #333;
		width: 100%;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}

	.price-content {
		color: #ff8a00;
		display: flex;
		align-items: flex-end;
		justify-content: flex-end;
	}

	.size-30 {
		font-size: 32px;
		margin-left: 4px;
		font-weight: bold;
	}

	.size-20 {
		font-size: 20px;
		margin-left: 6px;
		margin-bottom: 3px;
	}

	.size-26 {
		font-size: 26px;
	}

	.gray {
		color: #ccc;
	}

	.van-list__finished-text {
		width: 100%;
	}

	.loading {
		width: 300px;
		height: 300px;
		position: fixed;
		top: 30%;
		left: 50%;
		transform: translateX(-50%);
	}

	.self-icon {
		position: absolute;
		top: 0px;
		right: 0px;
		width: 117px;
		height: 117px;
		z-index: 3;
	}

	.lm-y {
		font-weight: 400;
		line-height: 36px;
		height: 36px;
		color: #FFFFFF;
		background-color: rgba(0, 0, 0, 0.3);
		border-radius: 18px;
		padding-left: 18px;
		padding-right: 18px;
	}
</style>